/* Tandy Club — mobile carousel for Row / grid blocks with "Swipeable carousel
 * on phones" turned on (data-tc-carousel on the .tc-row). On phones the shared
 * CSS turns the row's grid into a horizontal scroll-snap strip; this script
 * adds the dots, keeps the active dot in sync while swiping, starts members on
 * their own highlighted tier, and — when data-tc-carousel-auto="<ms>" is set —
 * auto-rotates the slides. Auto-rotate never runs for prefers-reduced-motion
 * visitors or in the theme editor, pauses while the carousel is off-screen or
 * the tab is hidden, and stops for good the moment the shopper touches it.
 */
(function () {
  'use strict';
  if (window.__tcCarousel) return;
  window.__tcCarousel = true;

  var MOBILE = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var REDUCED = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);

  function isMobile() { return MOBILE ? MOBILE.matches : true; }

  function slidesOf(grid) {
    return Array.prototype.filter.call(grid.children, function (el) {
      return el.nodeType === 1 && !el.hidden;
    });
  }

  function setup(row) {
    if (row.__tcCarousel) return;
    var grid = row.querySelector('.tc-row__grid');
    if (!grid || grid.children.length < 2) return;
    row.__tcCarousel = true;

    var autoMs = parseInt(row.getAttribute('data-tc-carousel-auto') || '0', 10) || 0;
    var interacted = false;
    var timer = null;
    var onScreen = true;
    var startedOnOwnTier = false;

    var dots = document.createElement('div');
    dots.className = 'tc-carousel-dots';
    grid.insertAdjacentElement('beforebegin', dots);

    function goTo(i, instant) {
      var list = slidesOf(grid);
      if (!list.length) return;
      i = ((i % list.length) + list.length) % list.length;
      var el = list[i];
      var left = el.offsetLeft - (grid.clientWidth - el.offsetWidth) / 2;
      if (grid.scrollTo) grid.scrollTo({ left: left, behavior: instant ? 'auto' : 'smooth' });
      else grid.scrollLeft = left;
    }

    function activeIndex(list) {
      var mid = grid.scrollLeft + grid.clientWidth / 2;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < list.length; i++) {
        var c = list[i].offsetLeft + list[i].offsetWidth / 2;
        var d = Math.abs(c - mid);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }

    function stopAuto() {
      interacted = true;
      if (timer) { clearInterval(timer); timer = null; }
    }

    function sync() {
      var list = slidesOf(grid);
      while (dots.children.length > list.length) dots.removeChild(dots.lastChild);
      while (dots.children.length < list.length) {
        (function (idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Go to item ' + (idx + 1));
          b.addEventListener('click', function () { stopAuto(); goTo(idx); });
          dots.appendChild(b);
        })(dots.children.length);
      }
      var a = activeIndex(list);
      for (var i = 0; i < dots.children.length; i++) {
        dots.children[i].classList.toggle('is-active', i === a);
      }
    }

    // Members start on their own tier: gate.js marks it .is-current-tier once
    // the visitor resolves — poll briefly, then follow late identification.
    function jumpToOwnTier() {
      if (startedOnOwnTier || interacted || !isMobile()) return;
      var mine = grid.querySelector('.is-current-tier');
      if (!mine) return;
      while (mine && mine.parentElement !== grid) mine = mine.parentElement;
      var idx = slidesOf(grid).indexOf(mine);
      if (idx < 0) return;
      startedOnOwnTier = true;
      goTo(idx, true);
      sync();
    }
    var tries = 0;
    var poll = setInterval(function () {
      jumpToOwnTier();
      if (startedOnOwnTier || ++tries > 40) clearInterval(poll);
    }, 250);
    document.addEventListener('tandyclub:customer-updated', jumpToOwnTier);

    // Keep the active dot in sync while swiping (and during smooth scrolls).
    var raf = null;
    function queueSync() {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; sync(); });
    }
    grid.addEventListener('scroll', queueSync, { passive: true });
    window.addEventListener('resize', queueSync);

    // Any real touch / click / wheel on the strip ends auto-rotation for good.
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
      grid.addEventListener(ev, stopAuto, { passive: true });
    });

    // Prev/next arrows overlaying the strip edges (wrap at the ends).
    ['prev', 'next'].forEach(function (dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tc-carousel-arrow tc-carousel-arrow--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Previous' : 'Next');
      b.innerHTML = dir === 'prev'
        ? '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 3 5 8l5 5"/></svg>'
        : '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 3 5 5-5 5"/></svg>';
      b.addEventListener('click', function () {
        stopAuto();
        goTo(activeIndex(slidesOf(grid)) + (dir === 'prev' ? -1 : 1));
      });
      row.appendChild(b);
    });

    if (autoMs && !DESIGN && !(REDUCED && REDUCED.matches)) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          onScreen = entries[0].isIntersecting;
        }, { threshold: 0.3 }).observe(row);
      }
      timer = setInterval(function () {
        if (interacted || !isMobile() || !onScreen || document.hidden) return;
        goTo(activeIndex(slidesOf(grid)) + 1);
      }, autoMs);
    }

    sync();
  }

  function scan(root) {
    var rows = (root || document).querySelectorAll('.tc-row[data-tc-carousel]');
    Array.prototype.forEach.call(rows, setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
